const TEXTS = {
  SELECTABLE_LIST_ALL: 'Выбрать все',
  SELECTABLE_LIST_ALL_NONE: 'Сбросить',
  SELECTABLE_LIST_FOUND: (count: number = 0) => `Найдено: ${count}`,
};

export default TEXTS;
